<svg version="1.1" id="Layer_1__x28_1:1_x29_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	 x="0px" y="0px" viewBox="0 0 304 74" style="enable-background:new 0 0 304 74;" xml:space="preserve">
<rect fill="none" width="304" height="74"/>
<g class="visa">
	<rect x="159.4" y="19" fill="#FFFFFF" width="56.6" height="36"/>
	<rect x="160.4" y="49.1" fill="#FCB316" width="54.7" height="4.9"/>
	<rect x="160.4" y="20" fill="#10357F" width="54.7" height="4.9"/>
	<path fill="#10357F" d="M182.3,30.3l-5.7,13.5h-3.7L170.1,33c0-0.5-0.4-1-0.8-1.2c-1.1-0.5-2.3-0.9-3.4-1.1l0.1-0.4h5.9
		c0.8,0,1.5,0.6,1.6,1.4l1.5,7.8l3.6-9.2C178.6,30.3,182.3,30.3,182.3,30.3z M196.7,39.4c0-3.6-4.9-3.8-4.9-5.3c0-0.5,0.5-1,1.5-1.1
		c1.2-0.1,2.4,0.1,3.4,0.6l0.6-2.9c-1-0.4-2.2-0.6-3.3-0.6c-3.4,0-5.9,1.8-5.9,4.5c0,1.9,1.7,3,3.1,3.7s1.8,1.1,1.8,1.7
		c0,0.9-1.1,1.3-2.1,1.3c-1.2,0-2.5-0.3-3.6-0.8l-0.6,3c1.2,0.5,2.6,0.7,3.9,0.7C194.3,44,196.7,42.2,196.7,39.4 M205.9,43.8h3.2
		l-2.8-13.5h-3c-0.7,0-1.2,0.4-1.5,1l-5.2,12.5h3.7l0.7-2h4.5L205.9,43.8z M202,39l1.8-5.1l1.1,5.1H202z M187.3,30.3l-2.9,13.5h-3.5
		l2.9-13.5L187.3,30.3z"/>
</g>
<g class="discover">
	<path fill="#EF7622" d="M285,38.9c0,0-14.8,10.5-42,15.2h42V38.9z"/>
	<path fill="#231F20" d="M285.2,19.5h-54.5v35h54.7v-35H285.2z M285,19.9v34.2h-53.9c0-0.4,0-33.8,0-34.2H285z"/>
	<path fill="#231F20" d="M235.5,30.2h-2.3v7.9h2.2c1,0.1,2.1-0.3,2.9-0.9c0.9-0.7,1.4-1.8,1.4-3c0-2.2-1.7-4-3.8-4
		C235.8,30.2,235.6,30.2,235.5,30.2z M237.3,36.2c-0.6,0.5-1.4,0.7-2.1,0.6h-0.4v-5.3h0.4c0.8-0.1,1.5,0.2,2.1,0.6
		c0.6,0.5,0.9,1.2,0.9,2C238.2,35,237.9,35.7,237.3,36.2z"/>
	<rect x="240.4" y="30.2" fill="#231F20" width="1.5" height="7.9"/>
	<path fill="#231F20" d="M245.7,33.2c-0.9-0.3-1.2-0.6-1.2-1s0.5-0.9,1.1-0.9c0.5,0,0.9,0.2,1.2,0.6l0.8-1.1c-0.6-0.6-1.5-0.9-2.3-0.9
		c-1.3-0.1-2.4,0.9-2.5,2.2v0.1c0,1.1,0.5,1.7,1.9,2.2c0.4,0.1,0.7,0.3,1.1,0.5c0.3,0.2,0.5,0.5,0.5,0.8c0,0.6-0.5,1.1-1.1,1.1
		c0,0,0,0-0.1,0c-0.7,0-1.4-0.4-1.7-1.1l-1,1c0.6,1,1.6,1.5,2.8,1.5c1.4,0.1,2.6-1,2.7-2.4c0-0.1,0-0.2,0-0.2
		C248,34.5,247.5,33.9,245.7,33.2z"/>
	<path fill="#231F20" d="M248.5,34.2c0,2.3,1.8,4.1,4.1,4.1h0.1c0.7,0,1.3-0.2,1.9-0.5V36c-0.5,0.5-1.1,0.9-1.9,0.9
		c-1.4,0-2.6-1.1-2.7-2.5c0-0.1,0-0.1,0-0.2c0-1.5,1.1-2.7,2.5-2.7c0,0,0,0,0.1,0c0.7,0,1.5,0.3,1.9,0.9v-1.9
		c-0.6-0.3-1.2-0.5-1.9-0.5C250.4,30,248.5,31.8,248.5,34.2L248.5,34.2z"/>
	<polygon fill="#231F20" points="266.9,35.5 264.8,30.2 263.1,30.2 266.4,38.3 267.3,38.3 270.7,30.2 269,30.2 	"/>
	<polygon fill="#231F20" points="271.4,38.1 275.8,38.1 275.8,36.8 272.9,36.8 272.9,34.7 275.7,34.7 275.7,33.3 272.9,33.3 
		272.9,31.6 275.8,31.6 275.8,30.2 271.4,30.2 	"/>
	<path fill="#231F20" d="M281.9,32.5c0-1.5-1-2.3-2.8-2.3h-2.3v7.9h1.5v-3.2h0.2l2.1,3.2h1.9l-2.5-3.3C281.2,34.6,282,33.7,281.9,32.5z
		 M278.8,33.9h-0.5v-2.4h0.5c1,0,1.5,0.4,1.5,1.2S279.8,33.9,278.8,33.9z"/>
	<path fill="#231F20" d="M283,30.6c0-0.1-0.1-0.2-0.3-0.2h-0.2v0.7h0.2v-0.3l0.2,0.3h0.2l-0.2-0.3C282.9,30.8,283,30.7,283,30.6z
		 M282.7,30.7L282.7,30.7v-0.2l0,0c0.1,0,0.1,0,0.1,0.1S282.8,30.7,282.7,30.7z"/>
	<path fill="#231F20" d="M282.7,30.1c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6l0,0
		C283.3,30.4,283.1,30.1,282.7,30.1L282.7,30.1z M282.7,31.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5l0,0
		C283.2,31,283,31.2,282.7,31.2L282.7,31.2z"/>
	<g>
		<g>
			<g>
				<g>
					<g>
						<defs>
							<path id="SVGID_1_" d="M255.2,34.3c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2s-1.9-4.2-4.2-4.2C257,30.1,255.2,32,255.2,34.3"/>
						</defs>
						<clipPath id="SVGID_2_">
							<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
						</clipPath>
						
						<linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="-2398.8782" y1="118.3307" x2="-2398.4338" y2="118.3307" gradientTransform="matrix(-6.5095 -10.1919 10.1919 -6.5095 -16560.0156 -23641.2422)">
							<stop  offset="0" style="stop-color:#F59F00"/>
							<stop  offset="0.2345" style="stop-color:#F49A01"/>
							<stop  offset="0.4995" style="stop-color:#F28D04"/>
							<stop  offset="0.6196" style="stop-color:#F18406"/>
							<stop  offset="0.7552" style="stop-color:#EF7B09"/>
							<stop  offset="1" style="stop-color:#ED6F0D"/>
						</linearGradient>
						<polygon style="clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);" points="267.3,36 261.1,26.3 251.4,32.5 257.6,42.2"/>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
<g class="mastercard">
	<g style="opacity:0">
		<rect x="89.4" y="18.3" fill="#FFFFFF" width="56.6" height="37.4"/>
	</g>
	<rect x="110.2" y="24.8" fill="#FF5F00" width="14.9" height="24.4"/>
	<path fill="#EB001B" d="M111.7,37c0-4.8,2.2-9.3,5.9-12.2c-6.7-5.3-16.5-4.1-21.8,2.6s-4.1,16.5,2.6,21.8c5.6,4.4,13.5,4.4,19.2,0
		C113.9,46.2,111.7,41.7,111.7,37z"/>
	<path fill="#F79E1B" d="M141.3,46.6v-0.5h0.2V46H141v0.1h0.2L141.3,46.6L141.3,46.6z M142.3,46.6V46h-0.2l-0.2,0.4l-0.2-0.4h-0.2v0.6
		h0.1v-0.5l0.2,0.4h0.1l0.2-0.4v0.5H142.3z"/>
	<path fill="#F79E1B" d="M142.7,37c0,8.6-6.9,15.5-15.5,15.5c-3.5,0-6.9-1.2-9.6-3.3c6.7-5.3,7.9-15,2.6-21.8c-0.8-1-1.6-1.8-2.6-2.6
		c6.7-5.3,16.5-4.1,21.8,2.6C141.6,30.1,142.7,33.5,142.7,37L142.7,37z"/>
</g>
<g class="amex">
	<g>
		<path fill="#0071CE" d="M68.6,50.7l-2.5-2.7l-2.5,2.7h-4.9l0,0H48.2V38.2h-5l6.2-14.1h6l2.2,4.8v-4.8H65l1.3,3.7l1.3-3.7h5.7v-2.2
			c0-1.3-1.1-2.3-2.3-2.3H21c-1.3,0-2.3,1.1-2.3,2.3v30.3c0,1.3,1.1,2.3,2.3,2.3h50c1.3,0,2.3-1.1,2.3-2.3v-1.5H68.6z"/>
		<g>
			<polygon fill="#0071CE" points="69.3,49.3 73.3,49.3 68.1,43.8 73.3,38.3 69.4,38.3 66.2,41.8 63,38.3 59.1,38.3 64.3,43.8 
				59.1,49.3 62.9,49.3 66.1,45.8 			"/>
			<polygon fill="#0071CE" points="52.8,46.8 52.8,45.1 59,45.1 59,42.6 52.8,42.6 52.8,40.8 59.1,40.8 59.1,38.3 49.8,38.3 
				49.8,49.3 59.1,49.3 59.1,46.8 			"/>
			<polygon fill="#0071CE" points="70.3,36.8 73.2,36.8 73.2,25.8 68.7,25.8 66.2,32.6 63.8,25.8 59.1,25.8 59.1,36.8 62.1,36.8 
				62.1,29.1 64.9,36.8 67.5,36.8 70.3,29.1 			"/>
			<path fill="#0071CE" d="M54.3,25.8h-3.8l-4.8,10.9H49l0.9-2.2h5l0.9,2.2h3.4L54.3,25.8z M50.8,32.1l1.5-3.6l1.5,3.6H50.8z"/>
		</g>
	</g>
	<polygon fill="#0071CE" points="70.5,43.5 73.3,46.5 73.3,40.5 	"/>
</g>
</svg>
